import { useEffect, useRef } from 'react';

import { Col, Row } from 'twyne-new.ui'

import CodeEditor from '../CodeEditor';

const HTML_HBS_HELPERS = [
  {
    title: 'A simple way for rendering TCPA consent without additional content.',
    height: "80px",
    html: `{{{tcpaconsent class="custom-tcpaconsent"}}}
`,
    annotations: [
      { row: 0, text: "This helper, when used without content, must be called with three curly braces." },
      { row: 1, text: "It can also accept a 'class' property (all helpers accept the `class` property for styling)." },
    ],
  },
  {
    title: 'A helper that groups TCPA consent content with customizable HTML elements.',
    height: "100px",
    html: `{{#tcpaconsent}}
  <span class="custom-group">
    {{{tcpaconsent_group class="custom-tcpaconsent_group"}}}
  </span>
{{/tcpaconsent}}`,
    annotations: [
      { row: 0, text: "When calling {{tcpaconsent}} with content, it must use two curly braces and a '#'" },
      { row: 1, text: "The content inside {{#tcpaconsent}} can be any HTML element, not just a <span>." },
      { row: 1, text: "Here, the <span> element is used as an example, and you can customize the class to match your styling needs." },
      { row: 2, text: "Inside this block, the {{tcpaconsent_group}} helper is used to render all DBA's." },
    ],
  },
  {
    title: 'A complex structure for rendering TCPA consent with grouped items and custom input fields.',
    height: "200px",
    html: `{{#tcpaconsent}}
  <span class="custom-group">
    {{#tcpaconsent_group}}
      <span class="custom-group-item">
        {{{tcpaconsent_input class="custom-input"}}} 
        {{{tcpaconsent_label class="custom-label"}}}
      </span>
    {{/tcpaconsent_group}}
  </span>
{{/tcpaconsent}}`,
    annotations: [
      { row: 1, text: "Here, an HTML element like <span> is used to group elements, " },
      { row: 1, text: "but it can be any HTML tag based on your styling needs." },
      { row: 2, text: "The {{#tcpaconsent_group}} helper is used here to render multiple DBA entries inside this block." },
      { row: 3, text: "Each item inside the group is wrapped with an HTML element (like <span>), " },
      { row: 3, text: "which can be customized with a class or any attribute." },
      { row: 5, text: "The {{tcpaconsent_input}} and {{tcpaconsent_label}} " },
      { row: 5, text: "are the custom elements that allows you to pass a class for styling" },
    ],
  },
]

export default function TcpaConsentDbaHelper() {
  return <>
    <p className='my-3'>These helpers is used for TCPA Consent DBA, use it change the way the checkbox of each dba is displayed. <br />You can copy and paste on TCPA Consent Text</p>
    <Row>
      {HTML_HBS_HELPERS.map((helper, idx) => <AceEditorItem {...helper} key={idx} idx={idx} />)}
    </Row>
  </>
}

const AceEditorItem = ({ title, html, height, annotations, idx }) => {
  const editorRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (editorRef.current) {
        const { editor } = editorRef.current
        editor.getSession().setAnnotations(annotations.map(annotation => ({ ...annotation, column: 0, type: "info" })))
      }
    }, 1000)
  }, [annotations])

  return <Col size="12" key={idx} className="mb-3 relative">
    <p className='m-0 font-italic'>{title}</p>
    <CodeEditor
      ref={editorRef}
      readOnly={true}
      language='html'
      theme="textmate"
      name={`mode-${idx}`}
      id={`mode-${idx}`}
      onChange={() => { }}
      value={html}
      width='100%'
      height={height}
    />
  </Col>
}

